import React, { useEffect, useState } from "react";
import { IoMdAdd } from "react-icons/io";
import { BsSend } from "react-icons/bs";
import MostPopularStopsChart from "./Popularstop";
import GenderDistributionChart from "./Genderdistribution";
import { transportdata } from "../../../services/DashboardService";
import { stoprequests } from "../../../services/DashboardService";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { updateReportAction } from "../../../store/actions/AuthActions";
import { Link } from "react-router-dom";
import Map from "./Map";
import { FaBus, FaRoute, FaIdBadge, FaMapMarkedAlt } from "react-icons/fa";
import { FaBusSimple } from "react-icons/fa6";
import { MdDepartureBoard } from "react-icons/md";
import { FaLongArrowAltRight } from "react-icons/fa";
import { FaArrowRight } from "react-icons/fa6";
const Admindashboard = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [stopdata, setStopdata] = useState([]);
  const [data, setData] = useState({
    active_buses: 0,
    active_routes: 0,
    pending_stop_requests: 0,
    active_pass_holders: 0,
  });
  useEffect(() => {
    transportdata()
      .then((res) => {
        setData(res?.data?.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  return (
    <div className="container-fluid">
      {/* <div className="row">
        <div className="col-6 col-md-3 mb-1" onClick={() => navigate("/buses")}>
          <div className="card d-flex flex-column gap-1 p-2">
            <span
              className="text-primary fw-semibold"
              style={{ fontSize: "1.1rem" }}
            >
              Active Bus
            </span>
            <strong style={{ fontSize: "1.5rem" }}>{data.active_buses}</strong>
            <span className="text-primary" style={{ cursor: "pointer" }}>
              View All Buses
            </span>
          </div>
        </div>
        <div
          className="col-6 col-md-3 mb-1"
          onClick={() => navigate("/routes")}
        >
          <div className="card d-flex flex-column gap-1 p-2">
            <span
              className="text-primary fw-semibold"
              style={{ fontSize: "1.1rem" }}
            >
              Active Routes
            </span>
            <strong style={{ fontSize: "1.5rem" }}>{data.active_routes}</strong>
            <span className="text-primary" style={{ cursor: "pointer" }}>
              View All Routes
            </span>
          </div>
        </div>
        <div className="col-6 col-md-3 mb-1">
          <div className="card d-flex flex-column gap-1 p-2">
            <span
              className="text-primary fw-semibold"
              style={{ fontSize: "1.1rem" }}
            >
              Active Pass Holders
            </span>
            <strong style={{ fontSize: "1.4rem" }}>
              {data.active_pass_holders}
            </strong>
            <span
              className="text-primary"
              style={{ cursor: "pointer" }}
              onClick={() => navigate("/passes")}
            >
              View Employee
            </span>
          </div>
        </div>
        <div className="col-6 col-md-3 mb-1">
          <div className="card d-flex flex-column gap-1 p-2">
            <span
              className="text-primary fw-semibold"
              style={{ fontSize: "1rem" }}
            >
              Pending Stop Requests
            </span>
            <strong style={{ fontSize: "1.4rem" }}>
              {data.pending_stop_requests}
            </strong>
            <span
              className="text-primary"
              style={{ cursor: "pointer" }}
              onClick={() => navigate("/stopsrequests")}
            >
              View Requests
            </span>
          </div>
        </div>
      </div> */}

      <div className="row g-3">
        {/* Active Buses */}
        <div className="col-6 col-md-3">
          <div
            className="card h-100 shadow-sm border-0 p-3 hover-lift"
            style={{ cursor: "pointer" }}
          >
            <div className="d-flex align-items-center gap-2 text-primary mb-2">
              <FaBus size={20} />
              <span className="fw-semibold fs-5">Active Buses</span>
            </div>
            <h4 className="fw-bold text-dark">{data.active_buses}</h4>
            <Link
              to="/buses"
              className="text-decoration-underline text-primary small"
            >
              View Details
              <FaLongArrowAltRight className="ms-1" />
            </Link>
          </div>
        </div>

        {/* Active Routes */}
        <div className="col-6 col-md-3">
          <div
            className="card h-100 shadow-sm border-0 p-3 hover-lift"
            style={{ cursor: "pointer" }}
          >
            <div className="d-flex align-items-center gap-2 text-success mb-2">
              <FaRoute size={20} />
              <span className="fw-semibold fs-5">Active Routes</span>
            </div>
            <h4 className="fw-bold text-dark">{data.active_routes}</h4>
            <Link
              to="/routes"
              className="text-decoration-underline text-success small"
            >
              View Details
              <FaLongArrowAltRight className="ms-1" />
            </Link>
          </div>
        </div>

        {/* Active Pass Holders */}
        <div className="col-6 col-md-3">
          <div
            className="card h-100 shadow-sm border-0 p-3 hover-lift"
            style={{ cursor: "pointer" }}
          >
            <div className="d-flex align-items-center gap-2 text-warning mb-2">
              <FaIdBadge size={20} />
              <span className="fw-semibold fs-5">Active Pass Holders</span>
            </div>
            <h4 className="fw-bold text-dark">{data.active_pass_holders}</h4>
            <Link
              to="/passes"
              className="text-decoration-underline text-warning small"
            >
              View Details
              <FaLongArrowAltRight className="ms-1" />
            </Link>
          </div>
        </div>

        {/* Pending Stop Requests */}
        <div className="col-6 col-md-3">
          <div
            className="card h-100 shadow-sm border-0 p-3 hover-lift"
            style={{ cursor: "pointer" }}
          >
            <div className="d-flex align-items-center gap-2 text-dark mb-2">
              <FaMapMarkedAlt size={20} />
              <span className="fw-semibold fs-5">Pending Pass Requests</span>
            </div>
            <h4 className="fw-bold text-dark">{data.pending_stop_requests}</h4>
            <Link
              to="/stopsrequests"
              className="text-decoration-underline text-dark small"
            >
              View Details
              <FaLongArrowAltRight className="ms-1" />
            </Link>
          </div>
        </div>
      </div>

      <div className="row mt-2">
        <div className="col-12 col-sm-7 mb-1">
          <Map />
          {/* <div className="p-2 d-flex justify-content-between align-items-center">
              <span className="text-primary fw-semibold">Current Trips</span>
              <Link
                className="btn btn-sm btn-outline-primary"
                to="/tracking/trackmap"
              >
                Live Tracking
              </Link>
            </div>
            <div className="card-body p-0">
              <CurrentTrip />
            </div> */}
        </div>
        <div className="col-12 col-sm-5 mb-1">
          <div className="card border rounded-3">
            <div className="p-2 fw-bold text-primary">Quick Actions</div>
            <div className="card-body p-0 px-2 pb-1">
              <div className="d-flex flex-wrap gap-3 pb-1">
                {[
                  {
                    label: (
                      <span style={{ fontSize: "0.9rem" }}>Available Bus</span>
                    ),
                    icon: <IoMdAdd size={16} />,
                    link: "/available-bus",
                  },
                  {
                    label: (
                      <span style={{ fontSize: "0.9rem" }}>Current Trip</span>
                    ),
                    icon: <FaBusSimple size={16} />,
                    link: "/current-trip",
                  },
                  {
                    label: (
                      <span style={{ fontSize: "0.9rem" }}>Today Boarding</span>
                    ),
                    icon: <MdDepartureBoard size={16} />,
                    onclick: () => {
                      dispatch(
                        updateReportAction({
                          label: "Driver Report",
                          value: "DriverReport",
                        })
                      );
                      navigate("/report");
                    },
                  },
                  {
                    label: (
                      <span style={{ fontSize: "0.9rem" }}>Send Broadcast</span>
                    ),
                    icon: <BsSend size={16} style={{ margin: "1px" }} />,
                    link: "/available-bus",
                  },
                ].map(({ label, icon, link, onclick }, idx) => (
                  <div
                    key={idx}
                    className="flex-grow-1"
                    style={{ minWidth: "130px" }}
                  >
                    {link ? (
                      <Link
                        to={link}
                        className="action-card card text-decoration-none rounded-4 border"
                      >
                        <div className="card-body p-1 d-flex align-items-center gap-1">
                          <div className="icon-box">{icon}</div>
                          <span className="label">{label}</span>
                        </div>
                      </Link>
                    ) : (
                      <div
                        className="action-card card rounded-4 border cursor-pointer"
                        onClick={onclick}
                      >
                        <div className="card-body p-1 d-flex align-items-center gap-1">
                          <div className="icon-box">{icon}</div>
                          <span className="label">{label}</span>
                        </div>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row mt-2">
        <div className="col-12 col-sm-6 mb-1">
          <GenderDistributionChart />
        </div>
        <div className="col-12 col-sm-6 mb-1">
          <MostPopularStopsChart />
        </div>
      </div>
    </div>
  );
};

export default Admindashboard;
